import { ICalculatorTheme } from '../../models/CalculatorTheme';
import { colors } from './colors';

export const calculatorTheme: ICalculatorTheme = {
  helperText: {
    color: colors.notTransactional.gray,
    lineHeight: '16px',
    textDecoration: 'underline',
    error: {
      marginTop: '4px',
    },
    success: {
      marginTop: '15px',
    },
  },
  infoIcon: {
    fillColor: colors.notTransactional.base,
    marginLeft: '4px',
  },
  calculatorWrapper: {
    mobile: {
      padding: '8px',
    },
    desktop: {
      padding: '8px',
    },
    backgroundColor: colors.neutral.grayLight,
  },
  calculatorHeader: {
    mobile: {
      color: colors.neutral.codGray,
      fontSize: '16px',
    },
    desktop: {
      color: colors.neutral.gray,
      fontSize: '15px',
    },
  },
  inputTitle: {
    fontWeight: 400,
    lineHeight: '17px',
    marginBottom: '7px',
    color: colors.neutral.gray,
  },
  estimationContainer: {
    color: colors.neutral.gray,
    backgroundColor: colors.neutral.white,
  },
  popover: {
    title: {
      color: colors.neutral.gray,
    },
    body: {
      color: colors.notTransactional.gray,
    },
  },
  inputContainer: {
    desktopGap: '2px',
    desktopWidth: 'calc(50% - 1%)',
    superDesktopGap: '8px',
    superDesktopWidth: 'calc(50% - 3%)',
  },
};
